import { IBasicStyledProps, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

interface IDisabledText extends IBasicStyledProps {
  disabled: boolean;
}

export const Container = styled.div`
  padding: 1rem 0;
  display: block;

  label {
    ${theme.typography.labelRegular}
  }

  label:focus-within {
    outline: 2px solid ${theme.color.border.selected};
    outline-offset: 2px;
    border-radius: 0.25rem;
  }

  svg {
    vertical-align: middle;
    padding-left: 0.4rem;
  }
`;

export const TooltipWrapper = styled.div`
  text-align: left !important;
  font-size: 0.9rem;
  padding: 0.2rem;
`;

export const Description = styled.div`
  padding-left: 2.25rem;
  a {
    text-decoration: underline;
  }
  a:hover {
    cursor: pointer;
  }

  margin-top: 0.25rem;
  color: ${theme.color.text.secondary};
  ${theme.typography.bodyRegular}
`;

export const DisabledTextWrapper = styled.div<IDisabledText>`
  color: ${(props) =>
    props.disabled ? theme.color.text.disabled : theme.color.text.primary};
`;
